import { render, staticRenderFns } from "./WarpUpgradeButton.vue?vue&type=template&id=780737e4&scoped=true&"
import script from "./WarpUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./WarpUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780737e4",
  null
  
)

export default component.exports